import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import "../VehiculeForm.css";
import api from '../../../api/config'

const StepTwoNeuf = ({ sendData, isActive, onNext, onPrevious, commonData, handleSave }) => {
    const [formData, setFormData] = useState({
        // CERTIFICAT DE VENTE
        vde_1: null, // "Société"
        vde_2_1: null, // "Date de la vente du véhicule" JJ
        vde_2_2: null, // "Date de la vente du véhicule" MM
        vde_2_3: null, // "Date de la vente du véhicule" AAAA

        // IDENTITE DU TITULAIRE
        tit_1: null, // "Vous êtes" 0: personne physique 1: personne morale
        // si personne physique
        tit_2: null, // "Sexe " 0: homme 1: femme
        tit_3: null, // "Nom de naissance et prénom"
        tit_4: null, // "Nom d'usage / d'époux.se"
        tit_5_1: null, // "Né.e le" JJ
        tit_5_2: null, // "Né.e le" MM
        tit_5_3: null, // "Né.e le" AAAA
        tit_6: null, // "Commune de naissance"
        tit_7: null, // "Département de naissance"
        tit_8: null, // "Pays de naissance"
        tit_9: null, // "Adresse mail"
        // si personne morale
        tit_10: null, // "Raison sociale"
        tit_11: null, // "N° SIRET, le cas échéant"
        tit_12: null, // "N° de la voie"
        tit_13: null, // "Extension (bis, ter, ...)"
        tit_14: null, // "Type de voie (rue, avenue, ...)"
        tit_15: null, // "Nom de la voie"
        tit_16: null, // "Code postal"
        tit_17: null, // "Commune"

        tit_18: null, // SIREN

        // CO-TITULAIRE
        cotit_0: null, // "Le véhicule est-il dans un cas de multi-propriété ?" 0: pas multipropriete 1: multipropriete
        // si oui
        cotit_1: null, // "Nombre de titulaires (C.4.1) "
        cotit_2: null, // "Le co-titulaire est " 0: personne physique 1: personne morale
        // si personne physique
        cotit_3: null, // "Nom de naissance et prénom"
        cotit_4: null, // "Nom d'usage / d'époux.se"
        // si personne morale
        cotit_5: null, // "Raison sociale"

        cotit_13: null, // "N° SIRET"

    });

    useEffect(() => {
        if (commonData) {
            if (commonData.stepTwoData && Object.keys(commonData.stepTwoData).length > 0) {
                setFormData(prevState => ({
                    ...prevState,
                    ...commonData.stepTwoData
                }));
            } else {
                const { numero_dossier, statut, vendeur_id } = commonData;
                setFormData(prevState => ({
                    ...prevState,
                    numero_dossier,
                    statut,
                    vendeur_id
                }));
            }
        }
    }, [commonData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
        const caseSensitiveFields = ['tit_9']; // email
        
        if (name === 'tit_11') {
            const numericValue = value.replace(/[^0-9]/g, '');
            setFormData((prev) => ({
                ...prev,
                [name]: numericValue,
                tit_18: numericValue.slice(0, 9), // auto-remplissage SIREN
            }));
            return;
        }

        if (name === 'tit_7') {
            const numericValue = value.replace(/[^0-9]/g, '');
            setFormData({
                ...formData,
                [name]: numericValue
            });
            return;
        }
        
        if (caseSensitiveFields.includes(name)) {
            setFormData({
                ...formData,
                [name]: value
            });
            return;
        }
        
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };
    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;

    //     const caseSensitiveFields = ['tit_9']; // email

    //     // --- TITULAIRE : saisie personne morale (RAISON SOCIALE / SIRET / SIREN) ---
    //     if (['tit_10', 'tit_11', 'tit_18'].includes(name)) {
    //         const isNumeric = ['tit_11', 'tit_18'].includes(name);
    //         const cleaned = isNumeric ? value.replace(/[^0-9]/g, '') : value.toUpperCase();

    //         setFormData(prev => {
    //             const next = { ...prev, [name]: cleaned, tit_1: '1' }; // 1 = personne morale

    //             // Auto-remplissage SIREN à partir du SIRET
    //             if (name === 'tit_11') {
    //                 next.tit_18 = cleaned.slice(0, 9);
    //             }

    //             // On vide les champs personne physique
    //             next.tit_2 = null;
    //             next.tit_3 = null;
    //             next.tit_4 = null;
    //             next.tit_5_1 = null;
    //             next.tit_5_2 = null;
    //             next.tit_5_3 = null;
    //             next.tit_6 = null;
    //             next.tit_7 = null;
    //             next.tit_8 = null;
    //             // (On laisse éventuellement tit_9 = email, si tu veux le conserver)

    //             return next;
    //         });
    //         return;
    //     }

    //     // --- TITULAIRE : saisie personne physique ---
    //     if ([
    //         'tit_3', 'tit_4',
    //         'tit_5_1', 'tit_5_2', 'tit_5_3',
    //         'tit_6', 'tit_7', 'tit_8', 'tit_9'
    //     ].includes(name)) {

    //         let nextVal = value;

    //         if (name === 'tit_7') {
    //             // département numérique
    //             nextVal = value.replace(/[^0-9]/g, '');
    //         } else if (!caseSensitiveFields.includes(name)) {
    //             nextVal = value.toUpperCase();
    //         }

    //         setFormData(prev => ({
    //             ...prev,
    //             [name]: nextVal,
    //             tit_1: '0',       // 0 = personne physique
    //             // on vide les champs personne morale
    //             tit_10: null,
    //             tit_11: null,
    //             tit_18: null,
    //         }));
    //         return;
    //     }

    //     // --- CO-TITULAIRE : saisie personne morale ---
    //     if (['cotit_5', 'cotit_13'].includes(name)) {
    //         const isNumeric = name === 'cotit_13';
    //         const cleaned = isNumeric ? value.replace(/[^0-9]/g, '') : value.toUpperCase();

    //         setFormData(prev => ({
    //             ...prev,
    //             [name]: cleaned,
    //             cotit_2: '1',   // personne morale
    //             // on vide la partie physique
    //             cotit_3: null,
    //             cotit_4: null,
    //         }));
    //         return;
    //     }

    //     // --- CO-TITULAIRE : saisie personne physique ---
    //     if (['cotit_3', 'cotit_4'].includes(name)) {
    //         setFormData(prev => ({
    //             ...prev,
    //             [name]: value.toUpperCase(),
    //             cotit_2: '0',   // personne physique
    //             // on vide la partie morale
    //             cotit_5: null,
    //             cotit_13: null,
    //         }));
    //         return;
    //     }

    //     // --- Champs "nombre" simples : ex. cotit_1 ---
    //     if (name === 'cotit_1') {
    //         const numericValue = value.replace(/[^0-9]/g, '');
    //         setFormData(prev => ({
    //             ...prev,
    //             cotit_1: numericValue || null,
    //         }));
    //         return;
    //     }

    //     // --- Fallback générique (inchangé) ---
    //     if (caseSensitiveFields.includes(name)) {
    //         setFormData(prev => ({
    //             ...prev,
    //             [name]: value,
    //         }));
    //         return;
    //     }

    //     if (name === 'tit_7') {
    //         const numericValue = value.replace(/[^0-9]/g, '');
    //         setFormData(prev => ({
    //             ...prev,
    //             [name]: numericValue,
    //         }));
    //         return;
    //     }

    //     setFormData(prev => ({
    //         ...prev,
    //         [name]: value.toUpperCase(),
    //     }));
    // };


    // const handleRadioChange = (name, value) => {
    //     setFormData({
    //         ...formData,
    //         [name]: value
    //     });
    // };
    const handleRadioChange = (name, value) => {
        setFormData(prev => {
            const updated = { ...prev, [name]: value };

            // Changement de type du titulaire
            if (name === 'tit_1') {
                if (value === '0') {
                    // personne physique -> on vide les champs "morale"
                    updated.tit_10 = null;
                    updated.tit_11 = null;
                    updated.tit_18 = null;
                } else if (value === '1') {
                    // personne morale -> on vide les champs "physique"
                    updated.tit_2 = null;
                    updated.tit_3 = null;
                    updated.tit_4 = null;
                    updated.tit_5_1 = null;
                    updated.tit_5_2 = null;
                    updated.tit_5_3 = null;
                    updated.tit_6 = null;
                    updated.tit_7 = null;
                    updated.tit_8 = null;
                    // éventuellement : updated.tit_9 = null;
                }
            }

            // Changement de type de co-titulaire
            if (name === 'cotit_2') {
                if (value === '0') {
                    // co-titulaire physique
                    updated.cotit_5 = null;
                    updated.cotit_13 = null;
                } else if (value === '1') {
                    // co-titulaire morale
                    updated.cotit_3 = null;
                    updated.cotit_4 = null;
                }
            }

            // Si on repasse "pas de multi-propriété", on vide tout le bloc co-titulaire
            if (name === 'cotit_0' && value === '0') {
                updated.cotit_1 = null;
                updated.cotit_2 = null;
                updated.cotit_3 = null;
                updated.cotit_4 = null;
                updated.cotit_5 = null;
                updated.cotit_13 = null;
            }

            return updated;
        });
    };

    const handleDateFieldChange = (e, fieldPrefix, part) => {
        const { value } = e.target;
        let newValue = value.replace(/[^0-9]/g, '');
        
        if (part === '1') { // Day
            // Only allow 01-31
            if (newValue.length > 2) newValue = newValue.slice(0, 2);
            if (newValue && parseInt(newValue) > 31) newValue = '31';
            if (newValue && parseInt(newValue) < 1 && newValue.length === 2) newValue = '01';
            // Only add leading zero when field loses focus or has 2 digits
            if (newValue.length === 1 && e.type === 'blur') {
                newValue = '0' + newValue;
            }
        } else if (part === '2') { // Month
            // Only allow 01-12
            if (newValue.length > 2) newValue = newValue.slice(0, 2);
            if (newValue && parseInt(newValue) > 12) newValue = '12';
            if (newValue && parseInt(newValue) < 1 && newValue.length === 2) newValue = '01';
            // Only add leading zero when field loses focus or has 2 digits
            if (newValue.length === 1 && e.type === 'blur') {
                newValue = '0' + newValue;
            }
        } else if (part === '3') { // Year
            // Only allow 4 digit years
            newValue = newValue.slice(0, 4);
            // Ensure year is not in the future
            const currentYear = new Date().getFullYear();
            if (newValue && parseInt(newValue) > currentYear && newValue.length === 4) 
                newValue = currentYear.toString();
        }
        
        setFormData({
            ...formData,
            [`${fieldPrefix}_${part}`]: newValue
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        sendData(formData);
        if (onNext) onNext();
    };

    const handlePrevious = () => {
        sendData(formData);
        if (onPrevious) onPrevious();
    };

    // Appel à l'API Sirene INSEE
    const [modalData, setModalData] = useState(null);
    const [modalError, setModalError] = useState(null);

    const handleSireneLookup = async (siretOrSiren) => {
    const cleaned = (siretOrSiren || "").replace(/\D/g, "");

    if (cleaned.length !== 9 && cleaned.length !== 14) {
        setModalError("Le numéro SIREN (9) ou SIRET (14) est invalide.");
        setModalData(null);
        return;
    }

    try {
        const response = await api.get(`/insee/verify/${cleaned}`);
        const etab = response.data.etablissement;
        const adr = etab?.adresseEtablissement || {};
        const ul = etab?.uniteLegale || {};

        setModalData(response.data);
        setModalError(null);

        setFormData((prev) => ({
            ...prev,
            tit_10: ul?.denominationUniteLegale || prev.tit_10,
            tit_12: adr?.numeroVoieEtablissement || prev.tit_12,
            tit_14: adr?.typeVoieEtablissement || prev.tit_14,
            tit_15: adr?.libelleVoieEtablissement || prev.tit_15,
            tit_16: adr?.codePostalEtablissement || prev.tit_16,
            tit_17: adr?.libelleCommuneEtablissement || prev.tit_17
        }));
    } catch (err) {
        setModalError(err.repsonse?.data?.message || err.message || "Erreur inconnue");
        setModalData(null);
    }
    };


    if (!isActive) return null;

    return (
        <>
            <div className="section">
                <h3>CERTIFICAT DE VENTE</h3>
                <div className="form-group">
                    <label htmlFor="vde_1">SOCIÉTÉ:</label>
                    <input
                        type="text"
                        id="vde_1"
                        name="vde_1"
                        value={formData.vde_1 || ''}
                        onChange={handleInputChange}
                        maxLength={100}
                    />
                </div>
    
                <div className="form-group">
                    <label>DATE DE LA VENTE DU VÉHICULE:</label>
                    <div className="date-input-group">
                        <div className="date-field">
                            <label htmlFor="vde_2_1">JOUR</label>
                            <input
                                type="text"
                                id="vde_2_1"
                                name="vde_2_1"
                                value={formData.vde_2_1 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'vde_2', '1')}
                                onBlur={(e) => handleDateFieldChange(e, 'vde_2', '1')}
                                placeholder="JJ"
                                maxLength="2"
                                required
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="vde_2_2">MOIS</label>
                            <input
                                type="text"
                                id="vde_2_2"
                                name="vde_2_2"
                                value={formData.vde_2_2 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'vde_2', '2')}
                                onBlur={(e) => handleDateFieldChange(e, 'vde_2', '2')}
                                placeholder="MM"
                                maxLength="2"
                                required
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="vde_2_3">ANNÉE</label>
                            <input
                                type="text"
                                id="vde_2_3"
                                name="vde_2_3"
                                value={formData.vde_2_3 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'vde_2', '3')}
                                placeholder="AAAA"
                                maxLength="4"
                                required
                            />
                        </div>
                    </div>
                </div>
    
                <div className="form-group certificate-text">
                    <p>
                        JE SOUSSIGNÉ.E {formData.vde_1 || '[NOM SOCIÉTÉ]'} CERTIFIE AVOIR VENDU CE VÉHICULE À LA PERSONNE DÉSIGNÉE CI-APRÈS LE {formData.vde_2_1 ? `${formData.vde_2_1}/${formData.vde_2_2}/${formData.vde_2_3}` : '[DATE]'}
                    </p>
                </div>
            </div>
    
            
    
            <div className="section">
                <h3>IDENTITÉ DU TITULAIRE</h3>
                <div className="radio-group">
                    <label>VOUS ÊTES:</label>
                    <div className='radio-group-child'>
                        <div>
                            <input
                                type="radio"
                                id="tit_1_physique"
                                name="tit_1"
                                value="0"
                                checked={formData.tit_1 === '0'}
                                onChange={() => handleRadioChange('tit_1', '0')}
                            />
                            <label htmlFor="tit_1_physique">PERSONNE PHYSIQUE</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="tit_1_morale"
                                name="tit_1"
                                value="1"
                                checked={formData.tit_1 === '1'}
                                onChange={() => handleRadioChange('tit_1', '1')}
                            />
                            <label htmlFor="tit_1_morale">PERSONNE MORALE</label>
                        </div>
                    </div>
                </div>
    
                {formData.tit_1 === '0' && (
                    <>
                        <div className="radio-group">
                            <label>SEXE:</label>
                            <div className='radio-group-child'>
                                <div>
                                    <input
                                        type="radio"
                                        id="tit_2_masculin"
                                        name="tit_2"
                                        value="0"
                                        checked={formData.tit_2 === '0'}
                                        onChange={() => handleRadioChange('tit_2', '0')}
                                    />
                                    <label htmlFor="tit_2_masculin">MASCULIN</label>
                                </div>
                                <div>
                                    <input
                                        type="radio"
                                        id="tit_2_feminin"
                                        name="tit_2"
                                        value="1"
                                        checked={formData.tit_2 === '1'}
                                        onChange={() => handleRadioChange('tit_2', '1')}
                                    />
                                    <label htmlFor="tit_2_feminin">FÉMININ</label>
                                </div>
                            </div>
                        </div>
    
                        <div className="form-group">
                            <label htmlFor="tit_3">NOM DE NAISSANCE ET PRÉNOM:</label>
                            <input
                                type="text"
                                id="tit_3"
                                name="tit_3"
                                value={formData.tit_3 || ''}
                                onChange={handleInputChange}
                                required
                                pattern="[A-Za-zÀ-ÿ\s\-']+"
                                title="Caractères alphabétiques, espaces, apostrophes et tirets uniquement"
                                maxLength={100}
                            />
                        </div>
    
                        <div className="form-group">
                            <label htmlFor="tit_4">NOM D&apos;USAGE / D&apos;ÉPOUX.SE:</label>
                            <input
                                type="text"
                                id="tit_4"
                                name="tit_4"
                                value={formData.tit_4 || ''}
                                onChange={handleInputChange}
                                pattern="[A-Za-zÀ-ÿ\s\-']+"
                                title="Caractères alphabétiques, espaces, apostrophes et tirets uniquement"
                                maxLength={100}
                            />
                        </div>
    
                        <div className="form-group">
                            <label>NÉ.E LE:</label>
                            <div className="date-input-group">
                                <div className="date-field">
                                    <label htmlFor="tit_5_1">JOUR</label>
                                    <input
                                        type="text"
                                        id="tit_5_1"
                                        name="tit_5_1"
                                        value={formData.tit_5_1 || ''}
                                        onChange={(e) => handleDateFieldChange(e, 'tit_5', '1')}
                                        onBlur={(e) => handleDateFieldChange(e, 'tit_5', '1')}
                                        placeholder="JJ"
                                        maxLength="2"
                                        required
                                    />
                                </div>
                                <div className="date-field">
                                    <label htmlFor="tit_5_2">MOIS</label>
                                    <input
                                        type="text"
                                        id="tit_5_2"
                                        name="tit_5_2"
                                        value={formData.tit_5_2 || ''}
                                        onChange={(e) => handleDateFieldChange(e, 'tit_5', '2')}
                                        onBlur={(e) => handleDateFieldChange(e, 'tit_5', '2')}
                                        placeholder="MM"
                                        maxLength="2"
                                        required
                                    />
                                </div>
                                <div className="date-field">
                                    <label htmlFor="tit_5_3">ANNÉE</label>
                                    <input
                                        type="text"
                                        id="tit_5_3"
                                        name="tit_5_3"
                                        value={formData.tit_5_3 || ''}
                                        onChange={(e) => handleDateFieldChange(e, 'tit_5', '3')}
                                        placeholder="AAAA"
                                        maxLength="4"
                                        required
                                    />
                                </div>
                            </div>
                        </div>
    
                        <div className="form-group">
                            <label htmlFor="tit_6">COMMUNE DE NAISSANCE:</label>
                            <input
                                type="text"
                                id="tit_6"
                                name="tit_6"
                                value={formData.tit_6 || ''}
                                onChange={handleInputChange}
                                required
                                pattern="[A-Za-zÀ-ÿ\s\-']+"
                                title="Caractères alphabétiques, espaces, apostrophes et tirets uniquement"
                                maxLength={50}
                            />
                        </div>
    
                        <div className="form-group">
                            <label htmlFor="tit_7">
                                DÉPARTEMENT DE NAISSANCE:
                                <span className="tooltip-icon" title="Merci d'indiquer le code de votre département à 3 chiffres, ex: 75015 => 075">?</span>
                            </label>
                            <input
                                type="text"
                                id="tit_7"
                                name="tit_7"
                                value={formData.tit_7 || ''}
                                onChange={handleInputChange}
                                pattern="[0-9]{3}"
                                title="Merci d'indiquer le code de votre département à 3 chiffres, ex: 75015 => 075"
                                maxLength={3}
                                required
                            />
                        </div>
    
                        <div className="form-group">
                            <label htmlFor="tit_8">PAYS DE NAISSANCE:</label>
                            <input
                                type="text"
                                id="tit_8"
                                name="tit_8"
                                value={formData.tit_8 || ''}
                                onChange={handleInputChange}
                                required
                                pattern="[A-Za-zÀ-ÿ\s\-']+"
                                title="Caractères alphabétiques, espaces, apostrophes et tirets uniquement"
                                maxLength={50}
                            />
                        </div>
    
                        <div className="form-group">
                            <label htmlFor="tit_9">ADRESSE MAIL:</label>
                            <input
                                type="email"
                                id="tit_9"
                                name="tit_9"
                                value={formData.tit_9 || ''}
                                onChange={handleInputChange}
                                pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
                                title="Adresse email valide (exemple: nom@domaine.com)"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="tit_12">N° DE LA VOIE:</label>
                            <input
                                type="text"
                                id="tit_12"
                                name="tit_12"
                                value={formData.tit_12 || ''}
                                onChange={handleInputChange}
                                pattern="^\d{1,4}$"
                                title="Veuillez entrer un numéro de voie valide (1 à 4 chiffres)"
                                maxLength="4"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="tit_13">EXTENSION (BIS, TER, ..):</label>
                            <input
                                type="text"
                                id="tit_13"
                                name="tit_13"
                                value={formData.tit_13 || ''}
                                onChange={handleInputChange}
                                maxLength={10}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="tit_14">TYPE DE VOIE (RUE, AVENUE, ..):</label>
                            <input
                                type="text"
                                id="tit_14"
                                name="tit_14"
                                value={formData.tit_14 || ''}
                                onChange={handleInputChange}
                                required
                                maxLength={20}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="tit_15">NOM DE LA VOIE:</label>
                            <input
                                type="text"
                                id="tit_15"
                                name="tit_15"
                                value={formData.tit_15 || ''}
                                onChange={handleInputChange}
                                required
                                maxLength={100}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="tit_16">CODE POSTAL:</label>
                            <input
                                type="text"
                                id="tit_16"
                                name="tit_16"
                                value={formData.tit_16 || ''}
                                onChange={handleInputChange}
                                required
                                pattern="^\d{5}$"
                                title="Le code postal doit contenir exactement 5 chiffres"
                                maxLength="5"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="tit_17">COMMUNE:</label>
                            <input
                                type="text"
                                id="tit_17"
                                name="tit_17"
                                value={formData.tit_17 || ''}
                                onChange={handleInputChange}
                                required
                                pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                                title="Veuillez entrer un nom de commune valide (lettres, espaces, tirets et apostrophes uniquement)"
                                maxLength="50"
                            />
                        </div>
                    </>
                )}
    
                {formData.tit_1 === '1' && (
                    <>
                        <div className="form-group">
                            <label htmlFor="tit_10">RAISON SOCIALE:</label>
                            <input
                                type="text"
                                id="tit_10"
                                name="tit_10"
                                value={formData.tit_10 || ''}
                                onChange={handleInputChange}
                                required
                                maxLength={100}
                            />
                        </div>

    
                        <div className="form-group siret-group">
                            <div className='input-group'>
                                <label htmlFor="tit_11">N° SIRET, LE CAS ÉCHÉANT:</label>
                                <input
                                    type="text"
                                    id="tit_11"
                                    name="tit_11"
                                    value={formData.tit_11 || ''}
                                    onChange={handleInputChange}
                                    pattern="[0-9]{14}"
                                    title="Le numéro SIRET doit comporter 14 chiffres"
                                    maxLength={14}
                                />
                            </div>
                            <button
                                type='button'
                                onClick={() => handleSireneLookup(formData.tit_11)}
                                className='save-button'
                                title="Vérifier via l'API Sirene"
                            >
                                Vérifier le SIRET
                            </button>
                        </div>
                        <div className="form-group">
                            <label htmlFor="tit_18">N° SIREN:</label>
                            <input
                                type="text"
                                id="tit_18"
                                name="tit_18"
                                value={formData.tit_18 || ''}
                                onChange={handleInputChange}
                                required
                                pattern="^\d{9}$"
                                title="Le numéro SIREN doit contenir exactement 9 chiffres"
                                maxLength="9"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="tit_12">N° DE LA VOIE:</label>
                            <input
                                type="text"
                                id="tit_12"
                                name="tit_12"
                                value={formData.tit_12 || ''}
                                onChange={handleInputChange}
                                required
                                pattern="^\d{1,4}$"
                                title="Veuillez entrer un numéro de voie valide (1 à 4 chiffres)"
                                maxLength="4"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="tit_13">EXTENSION (BIS, TER, ..):</label>
                            <input
                                type="text"
                                id="tit_13"
                                name="tit_13"
                                value={formData.tit_13 || ''}
                                onChange={handleInputChange}
                                maxLength={10}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="tit_14">TYPE DE VOIE (RUE, AVENUE, ..):</label>
                            <input
                                type="text"
                                id="tit_14"
                                name="tit_14"
                                value={formData.tit_14 || ''}
                                onChange={handleInputChange}
                                required
                                maxLength={20}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="tit_15">NOM DE LA VOIE:</label>
                            <input
                                type="text"
                                id="tit_15"
                                name="tit_15"
                                value={formData.tit_15 || ''}
                                onChange={handleInputChange}
                                required
                                maxLength={100}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="tit_16">CODE POSTAL:</label>
                            <input
                                type="text"
                                id="tit_16"
                                name="tit_16"
                                value={formData.tit_16 || ''}
                                onChange={handleInputChange}
                                required
                                pattern="^\d{5}$"
                                title="Le code postal doit contenir exactement 5 chiffres"
                                maxLength="5"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="tit_17">COMMUNE:</label>
                            <input
                                type="text"
                                id="tit_17"
                                name="tit_17"
                                value={formData.tit_17 || ''}
                                onChange={handleInputChange}
                                required
                                pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                                title="Veuillez entrer un nom de commune valide (lettres, espaces, tirets et apostrophes uniquement)"
                                maxLength="50"
                            />
                        </div>
                    </>
                )}
            </div>
    
            <div className="section">
                <h3>CO-TITULAIRE</h3>
                <div className="radio-group">
                    <label>LE VÉHICULE EST-IL DANS UN CAS DE MULTI-PROPRIÉTÉ?</label>
                    <div className='radio-group-child'>
                        <div>
                            <input
                                type="radio"
                                id="cotit_0_oui"
                                name="cotit_0"
                                value="1"
                                checked={formData.cotit_0 === '1'}
                                onChange={() => handleRadioChange('cotit_0', '1')}
                            />
                            <label htmlFor="cotit_0_oui">OUI</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="cotit_0_non"
                                name="cotit_0"
                                value="0"
                                checked={formData.cotit_0 === '0'}
                                onChange={() => handleRadioChange('cotit_0', '0')}
                            />
                            <label htmlFor="cotit_0_non">NON</label>
                        </div>
                    </div>
                </div>
    
                {formData.cotit_0 === '1' && (
                    <>
                        <div className="form-group">
                            <label htmlFor="cotit_1">NOMBRE DE TITULAIRES (C.4.1):</label>
                            <input
                                type="number"
                                id="cotit_1"
                                name="cotit_1"
                                value={formData.cotit_1 || ''}
                                onChange={handleInputChange}
                                min="2"
                                max="99"
                                required
                            />
                        </div>

                        <div className="radio-group">
                            <label>LE CO-TITULAIRE EST:</label>
                            <div className='radio-group-child'>
                                <div>
                                    <input
                                        type="radio"
                                        id="cotit_2_physique"
                                        name="cotit_2"
                                        value="0"
                                        checked={formData.cotit_2 === '0'}
                                        onChange={() => handleRadioChange('cotit_2', '0')}
                                    />
                                    <label htmlFor="cotit_2_physique">PERSONNE PHYSIQUE</label>
                                </div>
                                <div>
                                    <input
                                        type="radio"
                                        id="cotit_2_morale"
                                        name="cotit_2"
                                        value="1"
                                        checked={formData.cotit_2 === '1'}
                                        onChange={() => handleRadioChange('cotit_2', '1')}
                                    />
                                    <label htmlFor="cotit_2_morale">PERSONNE MORALE</label>
                                </div>
                            </div>
                        </div>

                        {formData.cotit_2 === '0' && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="cotit_3">NOM DE NAISSANCE ET PRÉNOM:</label>
                                    <input
                                        type="text"
                                        id="cotit_3"
                                        name="cotit_3"
                                        value={formData.cotit_3 || ''}
                                        onChange={handleInputChange}
                                        required
                                        pattern="[A-Za-zÀ-ÿ\s\-']+"
                                        title="Caractères alphabétiques, espaces, apostrophes et tirets uniquement"
                                        maxLength={100}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="cotit_4">NOM D&apos;USAGE / D&apos;ÉPOUX.SE:</label>
                                    <input
                                        type="text"
                                        id="cotit_4"
                                        name="cotit_4"
                                        value={formData.cotit_4 || ''}
                                        onChange={handleInputChange}
                                        pattern="[A-Za-zÀ-ÿ\s\-']+"
                                        title="Caractères alphabétiques, espaces, apostrophes et tirets uniquement"
                                        maxLength={100}
                                    />
                                </div>

                            </>
                        )}
                        {formData.cotit_2 === '1' && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="cotit_5">RAISON SOCIALE:</label>
                                    <input
                                        type="text"
                                        id="cotit_5"
                                        name="cotit_5"
                                        value={formData.cotit_5 || ''}
                                        onChange={handleInputChange}
                                        required
                                        maxLength={100}
                                    />
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>

            {/* Modal API Sirene */}
            {modalData && (
                <div className="modal-overlay">
                    <div className="modal-content modal-insee">
                        <h3>Informations Entreprise</h3>
                        <p>
                            <strong>Raison sociale :</strong>{" "}
                            {modalData.etablissement?.uniteLegale?.denominationUniteLegale ||
                            "[Non renseignée]"}
                        </p>

                        <p>
                            <strong>Nom :</strong>{" "}
                            {modalData.etablissement?.uniteLegale?.nomUniteLegale || "[Non renseigné]"}
                        </p>

                        <p>
                            <strong>Prénom :</strong>{" "}
                            {modalData.etablissement?.uniteLegale?.prenom1UniteLegale || "[Non renseigné]"}
                        </p>

                        <p>
                            <strong>Adresse :</strong>{" "}
                            {[
                            modalData.etablissement?.adresseEtablissement?.numeroVoieEtablissement,
                            modalData.etablissement?.adresseEtablissement?.typeVoieEtablissement,
                            modalData.etablissement?.adresseEtablissement?.libelleVoieEtablissement
                            ]
                            .filter(Boolean)
                            .join(" ") || "[Non renseignée]"}
                        </p>

                        <p>
                            <strong>Code postal :</strong>{" "}
                            {modalData.etablissement?.adresseEtablissement?.codePostalEtablissement || "[Non renseigné]"}
                        </p>

                        <p>
                            <strong>Commune :</strong>{" "}
                            {modalData.etablissement?.adresseEtablissement?.libelleCommuneEtablissement || "[Non renseignée]"}
                        </p>
                        <button className='finish-button' onClick={() => setModalData(null)}>Fermer</button>
                    </div>
                </div>
                )}

                {modalError && (
                <div className="error-message">
                    {modalError} <button className='finish-button' onClick={() => setModalError(null)}>Fermer</button>
                </div>
            )}

    
            <div className="button-container">
                <button type="button" className="prev-button" onClick={handlePrevious}>PRÉCÉDENT</button>
                <button type="button" className="save-button" onClick={() => handleSave(formData)}>ENREGISTRER</button>
                <button type="button" className="next-button" onClick={handleSubmit}>SUIVANT</button>
            </div>
        </>
    );
};

StepTwoNeuf.propTypes = {
    sendData: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func,
    commonData: PropTypes.object,
    handleSave: PropTypes.func.isRequired,
};

export default StepTwoNeuf;